import React, { useCallback, useEffect, useState } from 'react';
import * as cls from './why-integrate.module.css';
import { IMG_PATH } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';
import { CarouselHalf } from '../../../../ui/components/carousel-half';
import { UtilitiesLayout } from '../../../../ui/layouts/utilities-layout/utilities-layout';

const items = [
  {
    ico: `${IMG_PATH}/our-technology/apis-and-integrations/ico-accelerate.svg`,
    title: 'Accelerate development',
    text: 'Flexible APIs and data services shorten time to market.',
  },
  {
    ico: `${IMG_PATH}/our-technology/apis-and-integrations/ico-product.svg`,
    title: 'Enhance your product',
    text: 'Deliver smart, appliance-level insights automatically.',
  },
  {
    ico: `${IMG_PATH}/our-technology/apis-and-integrations/ico-scale.svg`,
    title: 'Scale confidently',
    text: 'Proven with utilities and energy platforms across Europe.',
  },
  {
    ico: `${IMG_PATH}/our-technology/apis-and-integrations/ico-compliance.svg`,
    title: 'Meet governance needs',
    text: 'Privacy, security and compliance considerations built into the integration approach.',
  },
];

export const WhyIntegrate = () => {
  const [perPage, setPerPage] = useState(4);

  const checkWidth = useCallback(() => {
    const width = window.innerWidth;
    if (width <= 600) {
      setPerPage(1);
    } else if (width <= 767) {
      setPerPage(2);
    } else if (width <= 999) {
      setPerPage(3);
    } else {
      setPerPage(4);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('resize', checkWidth);
    checkWidth();
    return () => window.removeEventListener('resize', checkWidth);
  }, [checkWidth]);

  return (
    <Section classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        Why Integrate with Voltaware
      </Typography>

      <CarouselHalf
        className={cls.carousel}
        defaultPerPage={false}
        perPage={perPage}
      >
        {items.map((item, index) => (
          <div className={cls.item} key={index}>
            <img src={item.ico} alt="" />
            <Typography as="p" tag="h3">
              {item.title}
            </Typography>
            <Typography>{item.text}</Typography>
          </div>
        ))}
      </CarouselHalf>

      <div className={cls.utilities}>
        <UtilitiesLayout />
      </div>
    </Section>
  );
};
